import { IResourceProvider } from 'common/resourceprovider';
import { success, clear } from 'common/dom/alerts';
import { htmlEncode } from 'common/functions/string';
import { WorkItemSubmitted } from 'runtime/events/workitemsubmitted';

let current: JQuery = null;

// viewUrl is null for hosts that must not offer a link to the submitted item; those get the plain transient toast.
export function showSubmittedAlert(resources: IResourceProvider, event: WorkItemSubmitted, viewUrl: (workItemId: string) => string): void {
    if (current) {
        clear(current);
        current = null;
    }

    if (!viewUrl) {
        success(resources.getCoreString('WorkItemSubmitted'));
        return;
    }

    // toastr renders the message as HTML, so the definition-computed title must be encoded.
    let message = event.title
        ? resources.getCoreString('WorkItemSubmittedNamed', htmlEncode(event.title))
        : resources.getCoreString('WorkItemSubmitted');
    message += `<div class="runtime-alert-action">${htmlEncode(resources.getCoreString('WorkItemSubmittedViewLink'))}</div>`;

    current = success(message, null, true);

    // Bound to the action element only: a toastr onclick covers the whole toast and dismisses it.
    current.find('.runtime-alert-action').on('click', () => {
        // Popup blockers return null rather than throwing.
        const opened = window.open(viewUrl(event.workItemId), '_blank');
        if (opened) {
            opened.focus();
        }
    });
}
